import { render, staticRenderFns } from "./Tasklist.vue?vue&type=template&id=25c2f1ac&scoped=true&"
import script from "./Tasklist.vue?vue&type=script&lang=js&"
export * from "./Tasklist.vue?vue&type=script&lang=js&"
import style0 from "./Tasklist.vue?vue&type=style&index=0&id=25c2f1ac&scoped=true&lang=css&"
import style1 from "./Tasklist.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c2f1ac",
  null
  
)

export default component.exports